var TooltipType = {
  TOOLTIP: 'tooltip',
  TOOLBAR: 'toolbar'
};

export { TooltipType };
//# sourceMappingURL=TooltipType.js.map
